export default __webpack_public_path__ + "static/media/text-symbol.5a97d069.svg";